import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { getHotArticles, formatViews } from '@/utils/data';

const hot = getHotArticles(6);

export default function HotRecommend() {
  const scroller = useRef<HTMLDivElement>(null);

  const scroll = (dir: 1 | -1) => {
    const el = scroller.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: 'smooth' });
  };

  return (
    <section className="w-full px-4 py-10 md:px-8 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-1.5 w-1.5 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
              <i className="ri-fire-line text-accent-500"></i>
              热门推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">编辑精选，附短评推荐</p>
          </div>
        </div>
        <div className="hidden items-center gap-2 sm:flex">
          <button
            type="button"
            aria-label="上一页"
            onClick={() => scroll(-1)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            type="button"
            aria-label="下一页"
            onClick={() => scroll(1)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>

      <div ref={scroller} className="flex snap-x gap-4 overflow-x-auto pb-2 no-scrollbar">
        {hot.map((a) => (
          <Link
            key={a.id}
            to={`/detail/${a.id}`}
            className="group flex w-[280px] shrink-0 snap-start flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer sm:w-[320px]"
          >
            <div className="relative h-40 w-full overflow-hidden bg-background-200">
              <img
                src={a.cover}
                alt={a.title}
                title={`${a.title} - 色哟哟娱乐资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
                {a.categoryName}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600">
                {a.title}
              </h3>
              <p className="mt-2 flex-1 rounded-md bg-background-100 p-3 text-xs leading-relaxed text-foreground-600 line-clamp-3">
                <span className="mr-1 font-medium text-primary-600">短评</span>
                {a.summary}
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span>{a.date}</span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {formatViews(a.views)}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}